import React, { useRef, useState } from 'react';
import './Surgical.css'
import { CgPlayButtonO } from "react-icons/cg";
import video from './Images/Surgical/sur.mp4';
import step1 from "./Images/Invisalign/IMG-20220517-WA0024.jpg";
import step2 from "./Images/Invisalign/DSC_0340.JPG";
import step3 from "./Images/Invisalign/sqr.jpg";
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from'../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {  FaCoffee, FaChild, FaClock,  FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard,  FaMedkit,  } from 'react-icons/fa';
import BookForm from '../book_now/BookForm';
function Surgical() 
{
    const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

    const bookFormRef = useRef(null);

    // Function to handle smooth scrolling
    const scrollToBookForm = (e) => {
      e.preventDefault();
      bookFormRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };
  const [openQuestion, setOpenQuestion] = useState(null);
    const togglePlay = () => {
        if (isPlaying) {
          videoRef.current.pause();
        } else {
          videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
      };
      const steps = [
        {
          image: step1,
          title: "In-Person Consult",
          description:
            "Meet with our implant teams to meet your needs",
        },
        {
          image: step2,
          title: "3-D Imaging",
          description:
            "Advanced tech help us ensure proper placement",
        },
        {
          image: step3,
          title: "Placement",
          description:
            "The implant is in one simple comfortable visit",
        },
   
      ];
      const toggleQuestion = (index) => {
        setOpenQuestion(openQuestion === index ? null : index);
      };
  const faqs = [
    { question: "Who is a candidate for dental implants?", answer: "Individuals with single or multiple missing teeth can get dental implants." },
    { question: "Is implant surgery painful?    ", answer: "Dental implant surgery at Bombay dental company, worli, Mumbai is done in the dental clinic itself under local anesthesia and it is completely painless. The patients can return to their regular work and routine on the same day.    " },
    { question: "Is Dental implant expensive?    ", answer: "Dental Implants done at Bombay dental company, Worli, Mumbai are completely affordable and economical. A range of low to mid and high range dental implants differing on their warranty periods are available to suit your pockets.    " },
    { question: "Can capping be done immediately after placement of dental implant?    ", answer: "Cap or crown placement for dental implant at Bombay dental company, worli, Mumbai is usually done 2-3 months after implant placement, so that implant stability is achieved before loading it. However temporary cap or crown can be given to replace the missing tooth.    " },
    { question: "What are immediate implants?    ", answer: "Immediate implants are placed at Bombay dental dental company, worli, Mumbai for outstation patients or travelling patients. The patients in which jaw bone condition is very good are usually the candidates for this procedure." },
  ];
const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="Surgical">
      <section className="surgical-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">
                INVISALIGN CLEAR BRACES IN WORLI, MUMBAI
              </mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk">Strong, reliable </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">tooth replacement </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">treatment</mark>
            </h1>
            <a onClick={scrollToBookForm}>
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">
              OR CALL <a href="tel:+918882672980">088826 72980</a>
            </p>
            {/* <p className="call-text2">9582474046</p> */}
          </div>
        </div>
      </section>
      <section className="dental-care-container">
        <div className="video-container" onClick={togglePlay}>
          <video
            ref={videoRef}
            className="video-thumbnail"
            src={video}
            type="video/mp4"
            loop
            muted
          />
          {!isPlaying && (
            <div className="play-button">
              <CgPlayButtonO />
            </div>
          )}
        </div>
        <div className="text-container">
          <h2>Are missing teeth reducing your confidence to smile?</h2>
          <p>
            Dental implants are a permanent and cost-effective solution to
            replace missing teeth by a team of experienced specialists and
            surgeons at Bombay dental company in Worli, Mumbai.
          </p>
        </div>
      </section>
      <div className="steps-container">
        <h1 className="steps-title">How it works</h1>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <img src={step.image} alt={step.title} className="step-image" />
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="insur">
        <div className="cost-insurance-container">
          <div className="payment-info">
            <div className="icon">💲</div> {/* Replace with actual icon */}
            <h4>Payment Info</h4>
            <h2>How much will it cost?</h2>
            <ul>
              <li>
                The cost of Invisalign at Bombay Dental company ranges from Rs
                95ooo – 2,50,000, depending on the case category.
              </li>
              <li>
                Unlike other dental clinics, Bombay dental company provides EMI
                payment options for your treatment.
              </li>
            </ul>
            <p>
              We'll never leave you in the dark. After your consultation, we’ll
              outline exactly what to budget for your Invisalign treatment.
            </p>
          </div>
          <div className="insurance-info">
            <h2>EMI Options</h2>
            <p>
              Our partners like Bajaj Insurance and Fibe EMI are available to
              guide patients personally, and help them to break down their
              payments into easy installments.
            </p>
            {/* <div className="insurance-icon">🏥</div>  */}
            {/* Replace with actual icon */}
          </div>
        </div>
      </div>
      <div className="faq-section">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <button
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              aria-controls={`faq-answer-${index}`}
              aria-expanded={openQuestion === index}
            >
              {faq.question} <span>{openQuestion === index ? "-" : "+"}</span>
            </button>
            {openQuestion === index && (
              <div id={`faq-answer-${index}`} className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>
      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
          </div>
        </div>
      </div>
      <div ref={bookFormRef}>
        <BookForm />
      </div>
    </div>
  );
}

export default Surgical
